import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgModule,
  NgZone,
  OnDestroy,
  Output
} from '@angular/core';

export interface MQ {
  type: 'max-width' | 'min-width';
  value: number;
}

@Directive({
  selector: '[appElementResize]',
})
export class ElementResizeDirective implements OnDestroy, AfterViewInit {
  @Input() mq: MQ;
  @Output() resizedEvent = new EventEmitter<boolean>();

  private previousIsValid: boolean;

  constructor(private el: ElementRef,
              private zone: NgZone) {
  }

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        this.onWindowResize();
      });
    });
  }

  ngOnDestroy(): void {
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.checkElementSize();
  }

  private checkElementSize(): void {
    if (!this.el.nativeElement) {
      return;
    }
    const width = this.el.nativeElement.offsetWidth;
    this.checkSize(width);
  }

  private checkSize(width: number): void {
    const isValid = this.isWidthValid(width);

    if (isValid !== this.previousIsValid) {
      this.previousIsValid = isValid;
      this.zone.run(() => {
        this.resizedEventEmitter(isValid);
      });
    }
  }

  private isWidthValid(width: number): boolean {
    if (!this.mq) {
      console.warn('ElementResizeDirective: mq input is not provided.');
      return false;
    }
    if (this.mq.type === 'max-width') {
      return width <= this.mq.value;
    } else if (this.mq.type === 'min-width') {
      return width >= this.mq.value;
    } else {
      console.error(`ElementResizeDirective: Unknown mq type: ${this.mq.type}`);
      return false;
    }
  }

  private resizedEventEmitter(val: boolean): void {
    this.resizedEvent.emit(val);
  }
}

@NgModule({
  exports: [
    ElementResizeDirective,
  ],
  declarations: [
    ElementResizeDirective,
  ],
})
export class ElementResizeModule {
}
